import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/web-config";
import axios from "axios";
import { toast } from "sonner";
import { handleDeleteResponse, handleGetResponse } from "./commonService";
import { handleErrorMessage } from "../../components/helper/common-function";

//get all listing of the address type
export const actionGetAddressTypeMaster = createAsyncThunk(
  "actionGetAddressTypeMaster",
  async ({ search = "", orderByColumn = "", order = "" } = {}) => {
    return handleGetResponse(
      `address-type-master?getall=YES${search ? `&search=${search}` : ""}${
        orderByColumn ? `&orderByColumn=${orderByColumn}` : ""
      }${order ? `&order=${order}` : ""}`
    );
  }
);

//add address type
export const actionAddAddressTypeMaster = createAsyncThunk(
  "actionAddAddressTypeMaster",
  async ({ values, handleCancel, form }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/address-type-master`,
        values
      );
      const { status, message: customMsg, data } = response.data;
      if (parseInt(status) === 200) {
        toast.success(customMsg, 5);
        form &&
          form.setFieldsValue({
            address_type_master_id: data?.address_type_master_id,
          });
        handleCancel && handleCancel();
        return data;
      } else {
        toast.error(customMsg, 5);
        return rejectWithValue(customMsg);
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  }
);

//delete address type master
export const actionDeleteAddressTypeMaster = createAsyncThunk(
  "actionDeleteAddressTypeMaster",
  async ({ id, setEditingKey }) => {
    return handleDeleteResponse(`address-type-master/${id}`, id, setEditingKey);
  }
);

//get single addres master
export const actionGetSingleAddressTypeMaster = createAsyncThunk(
  "actionGetSingleAddressTypeMaster",
  (id) => {
    return handleGetResponse(`address-type-master/${id}`);
  }
);

//update adddress type matster
export const actionEditAddressTypeMaster = createAsyncThunk(
  "actionEditAddressTypeMaster",
  async ({ id, req, setEditingKey, setEdited }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/address-type-master/${id}`,
        req
      );
      const { status, message: customMsg, data } = response.data;
      if (parseInt(status) === 200) {
        toast.success(customMsg, 5);
        setEditingKey && setEditingKey("");
        setEdited && setEdited(false);
        return data;
      } else {
        toast.error(customMsg, 5);
        return rejectWithValue(customMsg);
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  }
);
